<template>
  <div class="container">
    <!-- src="https://wap.maominglitchi.cn/" -->
    <iframe :src="url" frameborder="0" class="iframe"></iframe>
    <main-title :arrowClick="true">
      <template v-slot:rightBtn></template>
    </main-title>
    <hright-side></hright-side>
    <lengend-bar />
  </div>
</template>

<script>
const lengendBar = () => import("./page/legendBar");
const hrightSide = () => import("@/components/hrightSide");
export default {
  data() {
    return {
      url: process.env.VUE_APP_PUBLIC_PATH + "/html/glzy/index.html"
    };
  },
  components: {
    lengendBar,
    hrightSide
  }
};
</script>

<style lang="stylus" scoped>
.container
  width 100%
  height 100vh
  position relative
  overflow hidden
  >>>.header
    top 0
  .iframe
    width 100%
    height 100%
</style>
